<app-navbar [navClass]="'defaultscroll is-sticky'" [navLight]="false"></app-navbar>

<section class="relative lg:pb-24 pb-16 md:mt-[84px] mt-[70px]">
    <!-- Hero Section -->
    <div class="md:container container-fluid relative">
        <div class="relative overflow-hidden md:rounded-xl shadow-lg dark:shadow-gray-800 h-40 bg-gradient-to-r from-slate-50 to-gray-100 dark:from-slate-800 dark:to-slate-900 flex items-center justify-center">
            <div class="text-center">
                <div class="flex items-center justify-center mb-3">
                    <i data-feather="arrow-left" class="w-5 h-5 text-gray-600 dark:text-gray-400 mr-3 cursor-pointer" onclick="history.back()"></i>
                    <h1 class="text-2xl md:text-3xl font-semibold text-gray-900 dark:text-white">Online Check-In</h1>
                </div>
                <p class="text-gray-600 dark:text-gray-400">Complete your digital check-in process</p>
            </div>
        </div>
    </div>

    <div class="container relative md:mt-24 mt-16">
        <div class="max-w-7xl mx-auto">
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <!-- Main Check-in Content -->
                <div class="lg:col-span-2">
                    <div class="p-6 md:p-8 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
                        <!-- Welcome Message -->
                        <div class="mb-8 text-center">
                            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Welcome to Your Stay</h2>
                            <p class="text-gray-600 dark:text-gray-400">Let's get you checked in quickly and securely</p>
                        </div>

                        <!-- Progress Steps -->
                        <div class="mb-8">
                            <div class="flex items-center justify-between">
                                <div *ngFor="let step of steps; let i = index" class="flex items-center" [class.flex-1]="i < steps.length - 1">
                                    <!-- Step Circle -->
                                    <div
                                        (click)="goToStep(step.id)"
                                        [class]="isStepAccessible(step.id) ? 'cursor-pointer' : 'cursor-not-allowed'"
                                        class="relative">
                                        <div
                                            [class]="step.completed ? 'bg-green-500 border-green-500' :
                                                    step.active ? 'bg-red-500 border-red-500' :
                                                    'bg-gray-200 dark:bg-gray-700 border-gray-300 dark:border-gray-600'"
                                            class="w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all duration-200">
                                            <i *ngIf="step.completed" data-feather="check" class="w-5 h-5 text-white"></i>
                                            <span *ngIf="!step.completed"
                                                  [class]="step.active ? 'text-white' : 'text-gray-500 dark:text-gray-400'"
                                                  class="text-sm font-medium">{{ step.id }}</span>
                                        </div>
                                    </div>

                                    <!-- Step Connector -->
                                    <div *ngIf="i < steps.length - 1"
                                         [class]="step.completed ? 'bg-green-500' : 'bg-gray-200 dark:bg-gray-700'"
                                         class="flex-1 h-0.5 mx-4 transition-all duration-500">
                                    </div>
                                </div>
                            </div>

                            <!-- Step Labels -->
                            <div class="flex items-center justify-between mt-4">
                                <div *ngFor="let step of steps" class="text-center flex-1">
                                    <p class="text-xs text-gray-600 dark:text-gray-400 font-medium">{{ step.title }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- Step Content -->
                        <div class="min-h-[400px]">
                            <!-- Step 1: Booking Verification -->
                            <div *ngIf="currentStep === 1" class="space-y-6">
                                <div class="text-center mb-8">
                                    <div class="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <i data-feather="search" class="w-8 h-8 text-red-600"></i>
                                    </div>
                                    <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">Verify Your Booking</h3>
                                    <p class="text-gray-600 dark:text-gray-400">Enter your booking details to get started</p>
                                </div>

                                <form [formGroup]="bookingVerificationForm" (ngSubmit)="verifyBooking()" class="space-y-6">
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                            Booking ID
                                        </label>
                                        <input
                                            type="text"
                                            formControlName="bookingId"
                                            placeholder="Enter your booking ID (e.g., BK1234567890)"
                                            class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-white">
                                        <div *ngIf="bookingVerificationForm.get('bookingId')?.invalid && bookingVerificationForm.get('bookingId')?.touched"
                                             class="mt-1 text-sm text-red-600">
                                            Please enter a valid booking ID
                                        </div>
                                    </div>

                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                            Email Address
                                        </label>
                                        <input
                                            type="email"
                                            formControlName="email"
                                            placeholder="Enter the email used for booking"
                                            class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-white">
                                        <div *ngIf="bookingVerificationForm.get('email')?.invalid && bookingVerificationForm.get('email')?.touched"
                                             class="mt-1 text-sm text-red-600">
                                            Please enter a valid email address
                                        </div>
                                    </div>

                                    <button
                                        type="submit"
                                        [disabled]="bookingVerificationForm.invalid || isVerifyingBooking"
                                        class="w-full py-3 px-6 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 flex items-center justify-center">
                                        <div *ngIf="isVerifyingBooking" class="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                                        <span>{{ isVerifyingBooking ? 'Verifying...' : 'Verify Booking' }}</span>
                                    </button>
                                </form>

                                <!-- Verification Message -->
                                <div *ngIf="verificationMessage"
                                     [class]="verificationMessageType === 'success' ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-800 dark:text-green-200' :
                                             verificationMessageType === 'error' ? 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-800 dark:text-red-200' :
                                             'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-200'"
                                     class="p-4 border rounded-lg">
                                    <div class="flex items-start space-x-3">
                                        <i [attr.data-feather]="verificationMessageType === 'success' ? 'check-circle' :
                                                                verificationMessageType === 'error' ? 'x-circle' : 'info'"
                                           class="w-5 h-5 mt-0.5"></i>
                                        <p class="text-sm">{{ verificationMessage }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Step 2: ID Scanning -->
                            <div *ngIf="currentStep === 2" class="space-y-6">
                                <div class="text-center mb-8">
                                    <div class="w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <i data-feather="camera" class="w-8 h-8 text-blue-600"></i>
                                    </div>
                                    <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">Scan Your ID</h3>
                                    <p class="text-gray-600 dark:text-gray-400">Please scan or upload a photo of your identification document</p>
                                </div>

                                <!-- Document Type Selection -->
                                <div class="mb-6">
                                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
                                        Document Type
                                    </label>
                                    <div class="grid grid-cols-2 gap-4">
                                        <button
                                            type="button"
                                            (click)="onDocumentTypeChange('passport')"
                                            [class]="selectedDocumentType === 'passport' ?
                                                'bg-red-50 dark:bg-red-900/20 border-red-500 text-red-700 dark:text-red-300' :
                                                'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                                            class="p-4 border-2 rounded-lg transition-all duration-200 flex items-center justify-center space-x-3">
                                            <i data-feather="book" class="w-5 h-5"></i>
                                            <span class="font-medium">Passport</span>
                                        </button>
                                        <button
                                            type="button"
                                            (click)="onDocumentTypeChange('national_id')"
                                            [class]="selectedDocumentType === 'national_id' ?
                                                'bg-red-50 dark:bg-red-900/20 border-red-500 text-red-700 dark:text-red-300' :
                                                'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                                            class="p-4 border-2 rounded-lg transition-all duration-200 flex items-center justify-center space-x-3">
                                            <i data-feather="credit-card" class="w-5 h-5"></i>
                                            <span class="font-medium">National ID</span>
                                        </button>
                                    </div>
                                </div>

                                <!-- Verification Notice -->
                                <div class="mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
                                    <div class="flex items-start space-x-3">
                                        <i data-feather="clock" class="w-5 h-5 text-blue-600 mt-0.5"></i>
                                        <div>
                                            <h4 class="text-sm font-medium text-blue-900 dark:text-blue-200 mb-1">Verification Process</h4>
                                            <p class="text-sm text-blue-700 dark:text-blue-300">
                                                The verification process may take some time. We'll extract information from your document to speed up the check-in process.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <app-id-scanner
                                    [documentType]="selectedDocumentType"
                                    (scanComplete)="onIdScanComplete($event)"
                                    (scanError)="onIdScanError($event)">
                                </app-id-scanner>

                                <div class="mt-6 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
                                    <div class="flex items-start space-x-3">
                                        <i data-feather="shield" class="w-5 h-5 text-yellow-600 mt-0.5"></i>
                                        <div>
                                            <h4 class="text-sm font-medium text-yellow-900 dark:text-yellow-200 mb-1">Privacy & Security</h4>
                                            <p class="text-sm text-yellow-700 dark:text-yellow-300">
                                                Your document information is encrypted and securely processed. We only extract necessary details for verification.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Step 3: Guest Information Confirmation -->
                            <div *ngIf="currentStep === 3" class="space-y-6">
                                <div class="text-center mb-8">
                                    <div class="w-16 h-16 bg-purple-100 dark:bg-purple-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <i data-feather="user-check" class="w-8 h-8 text-purple-600"></i>
                                    </div>
                                    <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">Confirm Guest Information</h3>
                                    <p class="text-gray-600 dark:text-gray-400">Please verify and complete your guest details</p>
                                </div>

                                <form [formGroup]="guestConfirmationForm" (ngSubmit)="confirmGuestInformation()" class="space-y-6">
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                                First Name
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="firstName"
                                                class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-white">
                                        </div>

                                        <div>
                                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                                Last Name
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="lastName"
                                                class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-white">
                                        </div>
                                    </div>

                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                            Phone Number
                                        </label>
                                        <input
                                            type="tel"
                                            formControlName="phone"
                                            class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-white">
                                    </div>

                                    <!-- Trip Reason -->
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
                                            Reason for Trip
                                        </label>
                                        <div class="grid grid-cols-2 gap-4">
                                            <label class="relative">
                                                <input
                                                    type="radio"
                                                    formControlName="tripReason"
                                                    value="private"
                                                    class="sr-only">
                                                <div [class]="guestConfirmationForm.get('tripReason')?.value === 'private' ?
                                                    'bg-red-50 dark:bg-red-900/20 border-red-500 text-red-700 dark:text-red-300' :
                                                    'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                                                    class="p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 flex items-center justify-center space-x-3">
                                                    <i data-feather="home" class="w-5 h-5"></i>
                                                    <span class="font-medium">Private</span>
                                                </div>
                                            </label>
                                            <label class="relative">
                                                <input
                                                    type="radio"
                                                    formControlName="tripReason"
                                                    value="business"
                                                    class="sr-only">
                                                <div [class]="guestConfirmationForm.get('tripReason')?.value === 'business' ?
                                                    'bg-red-50 dark:bg-red-900/20 border-red-500 text-red-700 dark:text-red-300' :
                                                    'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                                                    class="p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 flex items-center justify-center space-x-3">
                                                    <i data-feather="briefcase" class="w-5 h-5"></i>
                                                    <span class="font-medium">Business</span>
                                                </div>
                                            </label>
                                        </div>
                                    </div>

                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                            Additional Guests (Optional)
                                        </label>
                                        <textarea
                                            formControlName="additionalGuests"
                                            rows="3"
                                            placeholder="List any additional guests..."
                                            class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 dark:bg-gray-800 dark:text-white">
                                        </textarea>
                                    </div>

                                    <div class="flex space-x-4">
                                        <button
                                            type="button"
                                            (click)="previousStep()"
                                            class="flex-1 py-3 px-6 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-200">
                                            Previous
                                        </button>
                                        <button
                                            type="submit"
                                            [disabled]="guestConfirmationForm.invalid"
                                            class="flex-1 py-3 px-6 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200">
                                            Continue
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <!-- Step 4: Access Code Generation -->
                            <div *ngIf="currentStep === 4" class="space-y-6">
                                <div class="text-center mb-8">
                                    <div class="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <i data-feather="key" class="w-8 h-8 text-green-600"></i>
                                    </div>
                                    <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">Generate Access Code</h3>
                                    <p class="text-gray-600 dark:text-gray-400">Get your room access code and check-in instructions</p>
                                </div>

                                <div *ngIf="!checkInData?.qrCodeGenerated" class="text-center">
                                    <button
                                        (click)="generateAccessCode()"
                                        [disabled]="isGeneratingAccess"
                                        class="py-4 px-8 bg-green-500 text-white rounded-lg hover:bg-green-600 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 flex items-center justify-center mx-auto">
                                        <div *ngIf="isGeneratingAccess" class="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                                        <i *ngIf="!isGeneratingAccess" data-feather="key" class="w-5 h-5 mr-3"></i>
                                        <span>{{ isGeneratingAccess ? 'Generating...' : 'Generate Access Code' }}</span>
                                    </button>
                                </div>

                                <!-- Access Code Display -->
                                <div *ngIf="checkInData?.qrCodeGenerated && checkInData?.qrCodeData" class="space-y-6">
                                    <div class="p-6 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg text-center">
                                        <div class="w-24 h-24 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                                            <i data-feather="check-circle" class="w-12 h-12 text-green-600"></i>
                                        </div>
                                        <h4 class="text-xl font-semibold text-green-900 dark:text-green-200 mb-2">Check-In Complete!</h4>
                                        <p class="text-green-700 dark:text-green-300">Your room access code has been generated successfully.</p>
                                    </div>

                                    <!-- QR Code and Access Details -->
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div class="p-6 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-center">
                                            <h5 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">QR Access Code</h5>
                                            <div class="w-32 h-32 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center mx-auto mb-4">
                                                <i data-feather="smartphone" class="w-16 h-16 text-gray-400"></i>
                                            </div>
                                            <p class="text-sm text-gray-600 dark:text-gray-400">Scan this code at your room door</p>
                                        </div>

                                        <div class="p-6 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg">
                                            <h5 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Access Details</h5>
                                            <div class="space-y-3">
                                                <div class="flex justify-between">
                                                    <span class="text-sm text-gray-600 dark:text-gray-400">Code:</span>
                                                    <span class="text-sm font-mono text-gray-900 dark:text-white">{{ checkInData?.qrCodeData?.code }}</span>
                                                </div>
                                                <div class="flex justify-between">
                                                    <span class="text-sm text-gray-600 dark:text-gray-400">Lock Code:</span>
                                                    <span class="text-sm font-mono text-gray-900 dark:text-white">{{ checkInData?.qrCodeData?.lockCode }}</span>
                                                </div>
                                                <div class="flex justify-between">
                                                    <span class="text-sm text-gray-600 dark:text-gray-400">Expires:</span>
                                                    <span class="text-sm text-gray-900 dark:text-white">{{ checkInData?.qrCodeData?.expiresAt | date:'short' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Instructions -->
                                    <div class="p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
                                        <h5 class="text-sm font-medium text-blue-900 dark:text-blue-200 mb-2">Access Instructions</h5>
                                        <p class="text-sm text-blue-700 dark:text-blue-300">{{ checkInData?.qrCodeData?.accessInstructions }}</p>
                                    </div>

                                    <!-- Action Buttons -->
                                    <div class="flex space-x-4">
                                        <button
                                            (click)="resetCheckIn()"
                                            class="py-2 px-6 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-200">
                                            Start New Check-In
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Booking Summary Sidebar -->
                <div class="lg:col-span-1">
                    <div class="sticky top-24">
                        <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
                            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-6">Booking Summary</h3>

                            <!-- Booking Details -->
                            <div *ngIf="verifiedBooking" class="space-y-4">
                                <!-- Booking ID -->
                                <div class="flex justify-between items-center py-2 border-b border-gray-100 dark:border-gray-700">
                                    <span class="text-sm text-gray-600 dark:text-gray-400">Booking ID</span>
                                    <span class="text-sm font-medium text-gray-900 dark:text-white">{{ verifiedBooking.bookingId }}</span>
                                </div>

                                <!-- Guest Name -->
                                <div class="flex justify-between items-center py-2 border-b border-gray-100 dark:border-gray-700">
                                    <span class="text-sm text-gray-600 dark:text-gray-400">Guest Name</span>
                                    <span class="text-sm font-medium text-gray-900 dark:text-white">
                                        {{ verifiedBooking.guestDetails?.firstName }} {{ verifiedBooking.guestDetails?.lastName }}
                                    </span>
                                </div>

                                <!-- Check-in Date -->
                                <div class="flex justify-between items-center py-2 border-b border-gray-100 dark:border-gray-700">
                                    <span class="text-sm text-gray-600 dark:text-gray-400">Check-in</span>
                                    <span class="text-sm font-medium text-gray-900 dark:text-white">
                                        {{ verifiedBooking.dateRange?.start | date:'MMM dd, yyyy' }}
                                    </span>
                                </div>

                                <!-- Check-out Date -->
                                <div class="flex justify-between items-center py-2 border-b border-gray-100 dark:border-gray-700">
                                    <span class="text-sm text-gray-600 dark:text-gray-400">Check-out</span>
                                    <span class="text-sm font-medium text-gray-900 dark:text-white">
                                        {{ verifiedBooking.dateRange?.end | date:'MMM dd, yyyy' }}
                                    </span>
                                </div>

                                <!-- Room Details -->
                                <div *ngIf="verifiedBooking.selectedRooms && verifiedBooking.selectedRooms.length > 0"
                                     class="py-2 border-b border-gray-100 dark:border-gray-700">
                                    <span class="text-sm text-gray-600 dark:text-gray-400 block mb-2">Room(s)</span>
                                    <div *ngFor="let room of verifiedBooking.selectedRooms" class="text-sm font-medium text-gray-900 dark:text-white">
                                        {{ room.roomName }} ({{ room.quantity }}x)
                                    </div>
                                </div>

                                <!-- Guests -->
                                <div class="flex justify-between items-center py-2 border-b border-gray-100 dark:border-gray-700">
                                    <span class="text-sm text-gray-600 dark:text-gray-400">Guests</span>
                                    <span class="text-sm font-medium text-gray-900 dark:text-white">
                                        {{ verifiedBooking.guests?.adults }} Adults
                                        <span *ngIf="(verifiedBooking?.guests?.children || 0) > 0">
                                            , {{ verifiedBooking?.guests?.children }} Children
                                        </span>
                                    </span>
                                </div>

                                <!-- Total Amount -->
                                <div class="flex justify-between items-center py-3 bg-gray-50 dark:bg-gray-800 rounded-lg px-4 mt-4">
                                    <span class="text-base font-semibold text-gray-900 dark:text-white">Total</span>
                                    <span class="text-base font-bold text-red-600">${{ verifiedBooking.total | number:'1.2-2' }}</span>
                                </div>
                            </div>

                            <!-- Placeholder when no booking verified -->
                            <div *ngIf="!verifiedBooking" class="text-center py-8">
                                <div class="w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <i data-feather="file-text" class="w-8 h-8 text-gray-400"></i>
                                </div>
                                <p class="text-gray-500 dark:text-gray-400 text-sm">
                                    Verify your booking to see details
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
<app-switcher></app-switcher>
